import { ListRange } from '../../../../../common/models/list.model';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import {
  ShipmentTransportOrderSapDeliveriesState,
  ShipmentTransportOrderSapDeliveriesStateModel,
} from './shipment-transport-order-sap-deliveries.state';
import {
  ShipmentTransportOrderSapDeliveriesInitialState,
  ShipmentTransportOrderSapDeliveriesLoad,
} from './shipment-transport-order-sap-deliveries.actions';
import { Injectable } from '@angular/core';
import { ShipmentSapDeliveryListSearchCriteria, ShipmentSapDeliveryModel } from '../../../../../common/models';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';
import { TransportOrderIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderSapDeliveriesFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderSapDeliveriesState.getLoaded);
  listDto$: Observable<ShipmentTransportOrderSapDeliveriesStateModel> = this.store.select(
    ShipmentTransportOrderSapDeliveriesState.getState,
  );
  sapDeliveries$: Observable<ShipmentSapDeliveryModel[]> = this.store.select(
    ShipmentTransportOrderSapDeliveriesState.getSapDeliveries,
  );

  constructor(private store: Store, private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade) {}

  loadAll(listRange?: ListRange): void {
    this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$
      .pipe(take(1))
      .subscribe((transportOrderIdView: TransportOrderIdView) => {
        this.store.dispatch(
          new ShipmentTransportOrderSapDeliveriesLoad(
            new ShipmentSapDeliveryListSearchCriteria({ ...listRange, transportOrderIdView }),
          ),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderSapDeliveriesInitialState());
  }
}
